//#region imports
import React from 'react';
import Container from '@mui/material/Container';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import cn from 'classnames';
import { Button } from '@mui/material';
import useMobile from 'hooks/useMobile';
//#endregion

interface IProps {
  className?: string;
  onSubscribe: () => void;
}

const Promo: React.FC<IProps> = ({ className, onSubscribe }) => {
  const { t } = useTranslation();
  const classes = styles();
  const { isMobile } = useMobile();

  return (
    <section className={ cn(className, classes.root) }>
      <Container className={ classes.container }>
        <div className={ classes.content }>
          <Typography variant="h2" className={ classes.title } color="inherit">
            { t('promo.title') }
          </Typography>
          <Typography className={ classes.desc } variant="body1" mb="20px">
            { t('promo.desc.0') }
          </Typography>
          { !isMobile &&
            <Typography className={ classes.desc } variant="body1" mb="20px" dangerouslySetInnerHTML={ { __html: t('promo.desc.1') } } />
          }
          <Button onClick={ onSubscribe } className={ classes.button } variant="contained" color="secondary" size="medium">
            { t('action.subscribe') }
          </Button>
          { isMobile &&
            <Typography className={ classes.desc } variant="body1" textAlign={ 'center' } mt={ '10px' } dangerouslySetInnerHTML={ { __html: t('promo.desc.1') } } />
          }
        </div>
      </Container>
    </section>
  );
};

export default Promo;
